module.exports = __webpack_public_path__ + "img/loader-dual-ring.bae8b2e3.svg";